import { render, staticRenderFns } from "./StudentManager.vue?vue&type=template&id=01f3898d&scoped=true&"
import script from "./StudentManager.vue?vue&type=script&lang=js&"
export * from "./StudentManager.vue?vue&type=script&lang=js&"
import style0 from "./StudentManager.vue?vue&type=style&index=0&id=01f3898d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3898d",
  null
  
)

export default component.exports